<template>
  <div v-if="(editMode || dgRowInEditMode[gridId + '.' + rowKey]) && !controlInfo.readonly">
    <b-form-checkbox v-model="value" @change="changeCheckboxValue" />
  </div>
  <div v-else>
    <b-form-checkbox v-model="value" :disabled="true" @change="changeCheckboxValue" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'editMode',
    'controlInfo',
  ],
  data() {
    return {
      value: this.cellVal,
    }
  },
  watch: {
    cellVal() {
      this.value = this.cellVal
    },
  },
  computed: {
    ...mapState(['currentDash', 'dgRowInEditMode']),
  },
  methods: {
    changeCheckboxValue(value) {
      const data = {
        options: this.options,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        value,
      }

      if (this.options.isReactive || typeof this.options.isReactive === 'undefined') {
        db.dataGrid.data.saveCellVal(data)
      } else {
        const rowInst = this.$instByClass(this, 'data-grid__row')

        rowInst.rowData[this.cellKey] = value
      }
    },
  },
  beforeDestroy() {
    this.value = null
  },
}
</script>
